import { User } from "./types";

export const dummyUser = (_?: any, index: number = 0): User => ({
  email: undefined,
  firstName: undefined,
  id: `dummyUser_${index}`,
  lastName: undefined,
  rank: undefined,
  profiles: [],
  username: undefined
});
